import React, {memo, useEffect, useState} from 'react';
import './style.css';
import {useInputWithFocus} from 'common/hook/useInputWithFocus';
import {Select,Spin} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import {optionsResponseType} from 'components/form/options/options';
import {ReactComponent as SelectArrayIcon} from '../../../../../../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../../../../../../../../assets/i/arrow-up-icon.svg';
import {ReactComponent as FileIcon} from '../../../../../../../../../assets/main/groups/form/file.svg';
import {ReactComponent as CloseIcon} from '../../../../../../../../../assets/header/сlose.svg';
import {ReactComponent as InfoSmallerIcon} from '../../../../../../../../../assets/main/test/info-smaller.svg';
import {useFileUpload} from "common/hook/use-file-upload";
import {useAppDispatch, useAppSelector} from "common/hook";
import {
    setTextTabData, TestItem
} from "features/model/slice/create-test/create-test-form/createTestForm";
import {FieldsRow} from "../../../../test-edit-item/test-descr-box/block-tabs/general/fields-row/FieldsRow";
import {useParams} from "react-router-dom";
import {addFile} from "features/model/service/test/file/add-file/addFile";
import {deleteFile} from "features/model/service/test/file/delete-file/deleteFile";
import TextArea from "antd/es/input/TextArea";
import {resetDeleteFile} from "features/model/slice/test/delete-file/deleteFileSlice";
import {resetAddFile, setErrorsFile} from "features/model/slice/lessons/response-add-file/responseAddFile";
import {Preloader} from "components/layout/preloader/Preloader";


interface IListeningTab {
    questionData?: TestItem;
}

export const ListeningTab = memo(({questionData}: IListeningTab) => {
    const dispatch = useAppDispatch()
    const [open, setOpen] = useState<boolean>(false);
    const filePatch = useAppSelector(state => state.responseAddFile)
    const {file, fileName, questionId,error} = filePatch
    const setDeleteFileSuccess = useAppSelector(state => state.deleteFile.success)
    const setDeleteFileQuestionId = useAppSelector(state => state.deleteFile.questionId)


    const [values, setValues] = useState<TestItem>(questionData as TestItem || {});

    const {testId} = useParams();

    const OnClickHandler = () => {
        setOpen(!open)
    }


    const onClickDeleteFile = (path: string) => {
        dispatch(deleteFile({testId, filePath: path, questionId: questionData?.id ?? ''}))
        handleFileRemove1(0)
    }


    const {
        isFilled,
        handleFocus,
        handleBlur
    } = useInputWithFocus([false, false, false, false, false, false, false, false, false]);


    const fetchFiles = async () => {
        try {
            await dispatch(addFile({file: uploadedFiles1, testId, questionId: questionData?.id ?? ''}));
        } catch (error) {
            console.error('Произошла ошибка при отправке файлов:', error);
        }
    };


    const {
        drag: drag1,
        fileNames: fileNames1,
        fileInputRef: fileInputRef1,
        handleFileUpload: handleFileUpload1,
        handleFileRemove: handleFileRemove1,
        handleFileChange: handleFileChange1,
        dragStartHandler: dragStartHandler1,
        dragLeaveHandler: dragLeaveHandler1,
        onDropHandler: onDropHandler1,
        uploadedFiles: uploadedFiles1,
        setFileNames,
        setUploadedFiles
    } = useFileUpload();


    useEffect(() => {
        if (uploadedFiles1.length > 0) {
            fetchFiles();
        }
    }, [uploadedFiles1]);


    useEffect(() => {

        if (error) {
            setFileNames([]);
            setUploadedFiles([])
        }
        else if (!error && fileNames1.length > 1) {
            dispatch(setErrorsFile({ success: false, error: '', errors: {} }));
        }
    }, [error, fileNames1.length]);




    useEffect(() => {
        if (filePatch.success && questionId === questionData?.id) {
            setValues((prevValues) => ({
                ...prevValues,
                file: {
                    path: file,
                    fileName: fileName,
                },
            }));
            dispatch(resetAddFile());
        }
    }, [filePatch.success, file, fileName, questionId, questionData?.id]);



    useEffect(() => {
        if (setDeleteFileSuccess && setDeleteFileQuestionId === questionData?.id) {
            // Сначала обновите состояние
            setValues((prevValues) => ({
                ...prevValues,
                file: {
                    path: '',
                    fileName: '',
                },
            }));

            // Затем вызовите dispatch после завершения обновления состояния
            dispatch(resetDeleteFile());
        }
    }, [setDeleteFileSuccess, setDeleteFileQuestionId, questionData?.id]);


    useEffect(() => {
        dispatch(setTextTabData(values));
    }, [values, dispatch]);

    const handleChange = (name: string, value: string) => {
        setValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };


    return (
        <>
            <div className="fields-row two-cols">
                <div className="field middle-w">
                    <div className="course-type" onClick={OnClickHandler}>
                        <span className={values.questionType ? 'active-label' : ''}>Тип ответа</span>
                        <Select
                            style={{width: '100%'}}
                            value={values.questionType}
                            className="custom-select select-new"
                            onChange={(value) => handleChange('questionType', value.toString())}
                            options={optionsResponseType}
                            onFocus={() => handleFocus(0)}
                            onBlur={handleBlur}
                            suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                        />
                    </div>
                </div>


                <div className="field large-w">
                    <div style={{width: '100%'}} className={`field ${isFilled[0] ? 'filled' : ''}`}>
                        <label className={`field-name ${values.questionTitle ? 'active-label' : ''}`}>
                            Текст вопроса
                        </label>
                        <div className="ant-select-selector">
                            <TextArea
                                name="questionTitle"
                                className="form-control  form-control-new"
                                value={values.questionTitle}
                                onChange={(event) => handleChange('questionTitle', event.target.value)}
                                onFocus={() => handleFocus(0)}
                                onBlur={handleBlur}
                                autoSize={{minRows: 1, maxRows: 10}}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="fields-row">
                <div className="field">
                    {drag1 ?
                        <div
                            onDragStart={(e) => dragStartHandler1(e)}
                            onDragLeave={(e) => dragLeaveHandler1(e)}
                            onDragOver={(e) => dragStartHandler1(e)}
                            onDrop={(e) => onDropHandler1(e)}
                            onClick={handleFileUpload1}
                            className="upload-box upload-box-drop"
                        >
                            <p>Перетащите аудиозапись сюда или</p>
                        </div> :
                        <div className={fileNames1.length === 1 ? 'upload-box file-disabled' : 'upload-box'}>
                            <div
                                onDragStart={(e) => dragStartHandler1(e)}
                                onDragLeave={(e) => dragLeaveHandler1(e)}
                                onDragOver={(e) => dragStartHandler1(e)}
                                onDrop={(e) => onDropHandler1(e)}
                                className="form-button"
                                onClick={handleFileUpload1}
                            >
                                <FileIcon/>
                                <p
                                    onDragStart={(e) => dragStartHandler1(e)}
                                    onDragLeave={(e) => dragLeaveHandler1(e)}
                                    onDragOver={(e) => dragStartHandler1(e)}
                                    onDrop={(e) => onDropHandler1(e)}
                                >
                                    Перетащите аудиозапись сюда или <a>выберите файл</a>
                                </p>
                            </div>

                            <input
                                id="files"
                                type="file"
                                name="files"
                                ref={fileInputRef1}
                                style={{display: "none"}}
                                onChange={handleFileChange1}
                                multiple={true}
                                disabled={fileNames1.length === 1}
                            />
                        </div>
                    }

                    <div className="uploaded-files">
                        <ul className="uploaded-files-list">
                            {values.file?.fileName ? (
                                <li>
                                    <span
                                        className="js-remove-file"
                                        onClick={() => onClickDeleteFile(values.file?.path || '')}
                                    >
                                      <CloseIcon/>
                                    </span>
                                    <div className="file-name">
                                        <span>{values.file?.fileName}</span>
                                    </div>
                                </li>
                            ) : (
                                fileNames1 && fileNames1.map((fileName, index) => (
                                    <li key={index}>
                                        <span className="js-remove-file"
                                              onClick={() => onClickDeleteFile(values.file?.path || '')}>
                                            <CloseIcon/>
                                        </span>
                                        <div className="file-name">
                                               <span>
                                                   {questionData?.file?.fileName || fileName}
                                               </span>
                                            <span style={{paddingLeft: '10px'}}><Spin size="small"/></span>
                                        </div>
                                    </li>
                                ))
                            )}
                        </ul>
                        {error && <p className="field-error">{error}</p>}
                    </div>

                </div>
            </div>
            {values.questionType === 'determineProcedure' &&
                <p className="p-icon info-icon">
                    Сначала введите правильный порядок слов или фраз, а затем перемешайте последовательность.
                    <span className="icon">
                        <InfoSmallerIcon/>
                </span>
                </p>
            }
            <FieldsRow values={values}/>
        </>
    );
});


